import { defaultFill } from './utils/constants';
var muiChevronDownBase = {
    paths: [
        {
            path: 'M6.00701071,7 C5.86368062,7 5.72930867,6.97777962 5.60389484,6.93333885 C5.47848101,6.88889809 5.36202532,6.81334879 5.25452775,6.70669096 L0.282765336,1.77376615 C0.0856864654,1.57822679 -0.00837390458,1.33380258 0.000584225901,1.04049354 C0.00954235638,0.747184498 0.112560857,0.502760296 0.309639727,0.307220934 C0.506718598,0.111681572 0.757546251,0.0139118914 1.06212269,0.0139118914 C1.36669912,0.0139118914 1.61752678,0.111681572 1.81460565,0.307220934 L6.00701071,4.46687645 L10.2262902,0.280556476 C10.423369,0.0850171138 10.6697176,-0.00830849067 10.9653359,0.00057966214 C11.2609542,0.00946781495 11.5073028,0.111681572 11.7043817,0.307220934 C11.9014606,0.502760296 12,0.751628575 12,1.05382577 C12,1.35602297 11.9014606,1.60489124 11.7043817,1.80043061 L6.75949367,6.70669096 C6.65199611,6.81334879 6.53554041,6.88889809 6.41012658,6.93333885 C6.28471276,6.97777962 6.1503408,7 6.00701071,7 Z',
            fill: defaultFill,
        },
    ],
    title: 'chevron down',
    width: 24,
    height: 24,
    rotate: 0,
    translate: [6, 8],
};
var muiChevronDown = {
    base: muiChevronDownBase,
};
export { muiChevronDown };
//# sourceMappingURL=chevronDown.js.map